(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[412],{

/***/ 70412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contacts; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./components/contacts/Contacts.module.scss
var Contacts_module = __webpack_require__(55389);
var Contacts_module_default = /*#__PURE__*/__webpack_require__.n(Contacts_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/contacts/Contacts.js





 // const ShopsMap = dynamic(() => import('../shopsMap/ShopsMap'), {
//   loading: () => <Loader />,
// });





var Contacts = function Contacts() {
  var infoRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var toggleDrawer = function toggleDrawer() {
    setIsOpen(function (prevState) {
      return !prevState;
    });
  }; // const [height, setHeight] = useState();
  // const onResize = useCallback(() => {
  //   setHeight(infoRef.current.clientHeight);
  // }, []);
  // useEffect(() => {
  //   onResize();
  //   window.addEventListener('resize', onResize);
  //   return () => {
  //     window.removeEventListener('resize', onResize);
  //   };
  // }, [onResize]);


  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* MessageForm */.CL, {
        isOpen: isOpen,
        toggleDrawer: toggleDrawer
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Contacts_module_default()).info,
        ref: infoRef,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
          component: "h2",
          className: (Contacts_module_default()).title,
          children: "\u041E\u0414\u041E \xAB\u0411\u0435\u043B\u0412\u0438\u0440\u0438\u043D\u0435\u044F\xBB"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Contacts_module_default()).phoneInfo,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: (Contacts_module_default()).phone,
            href: "tel:+375296332633",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
              name: "phone-fill-contacts",
              className: (Contacts_module_default()).icon
            }), "+375 (29) 633-2-633"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Contacts_module_default()).time,
            children: ["\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B: ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "09:00 \u2014 21:00"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Contacts_module_default()).addressInfo,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: (Contacts_module_default()).addressTitle,
            children: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0438 \u043F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Contacts_module_default()).legal,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Contacts_module_default()).name,
              children: "\u041E\u0414\u041E \xAB\u0411\u0435\u043B\u0412\u0438\u0440\u0438\u043D\u0435\u044F\xBB \u0423\u041D\u041F 190706320"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Contacts_module_default()).address,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                name: "shop-map",
                className: (Contacts_module_default()).iconPin
              }), "\u0433. \u041C\u0438\u043D\u0441\u043A, \u0443\u043B. \u041D\u0435\u043C\u0438\u0433\u0430 5, \u043F\u043E\u043C.39"]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Contacts_module_default()).addressInfo,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: (Contacts_module_default()).addressTitle,
            children: "\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442 \u043F\u043E \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0443"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Contacts_module_default()).phoneInfo,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (Contacts_module_default()).phone,
              href: "tel:+375445849765",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                name: "phone-fill-contacts",
                className: (Contacts_module_default()).icon
              }), "+375 (44) 584-97-65"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Contacts_module_default()).time,
              children: ["\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B: ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "\u041F\u043D-\u041F\u0442: \u0441 9:00 \u0434\u043E 18:00, \u0421\u0431-\u0412\u0441: \u0432\u044B\u0445\u043E\u0434\u043D\u043E\u0439"
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Contacts_module_default()).mails,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Contacts_module_default()).mailsBlock,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: "\u041F\u043E \u043E\u0431\u0449\u0438\u043C \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                className: (Contacts_module_default()).mail,
                href: "mailto:fh@fh.by",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "envelope",
                  className: (Contacts_module_default()).icon
                }), "fh@fh.by"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Contacts_module_default()).mailsBlockMobile,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: "\u041F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u0439 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                className: (Contacts_module_default()).mail,
                href: "mailto:otzyv@fh.by",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "envelope",
                  className: (Contacts_module_default()).icon
                }), "otzyv@fh.by"]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Contacts_module_default()).mailsBlock,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: "\u041F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u0440\u0435\u043A\u043B\u0430\u043C\u044B"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                className: (Contacts_module_default()).mail,
                href: "mailto:reklama@fh.by",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "envelope",
                  className: (Contacts_module_default()).icon
                }), "reklama@fh.by"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Contacts_module_default()).mailsBlockMobile,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: "\u041F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u0442\u0440\u0443\u0434\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                className: (Contacts_module_default()).mail,
                href: "mailto:personal@fh.by",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                  name: "envelope",
                  className: (Contacts_module_default()).icon
                }), "personal@fh.by"]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          type: "defaultBlack",
          classNames: {
            general: (Contacts_module_default()).button
          },
          onClick: function onClick() {
            router_default().push('/store-addresses');
          },
          children: "\u0410\u0434\u0440\u0435\u0441\u0430 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Button */.zx, {
          type: "defaultBlack",
          classNames: {
            general: (Contacts_module_default()).button
          },
          onClick: function onClick() {
            toggleDrawer();
          },
          children: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u043D\u0430\u043C"
        })]
      })]
    })
  });
};

/* harmony default export */ var contacts_Contacts = (Contacts);
;// CONCATENATED MODULE: ./components/contacts/index.js

/* harmony default export */ var contacts = (contacts_Contacts);

/***/ }),

/***/ 55389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mapAddress":"Contacts_mapAddress__vlhJa","map":"Contacts_map__x2abe","visibleMap":"Contacts_visibleMap__25e12","invisibleMap":"Contacts_invisibleMap__lJZ9S","info":"Contacts_info__hCcXA","icon":"Contacts_icon__DLN07","title":"Contacts_title__cIjHl","phoneInfo":"Contacts_phoneInfo__g74Jh","phoneTitle":"Contacts_phoneTitle__GQ_L7","phone":"Contacts_phone__kWdY_","time":"Contacts_time__irlZw","addressInfo":"Contacts_addressInfo__q8GfB","addressTitle":"Contacts_addressTitle__HZUk4","legal":"Contacts_legal__YP88L","name":"Contacts_name__srKac","address":"Contacts_address__peUck","iconPin":"Contacts_iconPin__FBS1m","mails":"Contacts_mails__3jSCB","mail":"Contacts_mail__QtAJ9","mailsBlock":"Contacts_mailsBlock__PUNIU","mailsBlockMobile":"Contacts_mailsBlockMobile__3jHOs","button":"Contacts_button__XSGrS","load":"Contacts_load__GU1M_"};

/***/ })

}]);